export default "__VITE_ASSET__CbzKWGpS__"